import "./BathroomRenovationKarlstad.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import Localserviceareas from "./sections/Localserviceareas";
import Renovationprocesssteps from "./sections/Renovationprocesssteps";
import Premiummaterialselection from "./sections/Premiummaterialselection";
import Swedishpricingfactors from "./sections/Swedishpricingfactors";
import Bathroomrenovationfaq from "./sections/Bathroomrenovationfaq";
import ExpertiseAndCoordination from "./sections/ExpertiseAndCoordination";
import QualityAndSafetyStandards from "./sections/QualityAndSafetyStandards";
import TrustAndRotDeduction from "./sections/TrustAndRotDeduction";
import Finalbookingcta from "./sections/Finalbookingcta";
import Footer from "@/reusable_sections/Footer";
export default function BathroomRenovationKarlstadPage() {
  return <div>
      <Header />
      <HeroSection />
      <Localserviceareas />
      <Renovationprocesssteps />
      <Premiummaterialselection />
      <Swedishpricingfactors />
      <Bathroomrenovationfaq />
      <ExpertiseAndCoordination />
      <QualityAndSafetyStandards />
      <Finalbookingcta />
      <TrustAndRotDeduction />
      <Footer />
    </div>;
}